import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

interface LastSync {
  started_at: string
  finished_at: string | null
  status: string | null
  triggered_by: string | null
}

export interface OrgSyncStatus {
  last_sync: LastSync | null
  tenants_synced: number
}

/** Resposta do disparo (202): o sync roda em segundo plano. */
export interface OrgSyncTriggerResult {
  status: 'started' | 'already_running'
  log_id?: number
  started_at?: string
  triggered_by?: string
}

export function isSyncRunning(status: OrgSyncStatus | undefined): boolean {
  return status?.last_sync?.status === 'running'
}

export function useOrgSyncStatus() {
  return useQuery<OrgSyncStatus>({
    queryKey: ['org-sync-status'],
    queryFn: async () => {
      const res = await api.get<OrgSyncStatus>('/v1/admin/org-sync/status')
      return res.data
    },
    // Enquanto houver um sync em andamento, faz polling a cada 5s para
    // refletir a conclusão (o sync agora roda em background; ver OrgSyncButton).
    refetchInterval: (query) =>
      query.state.data?.last_sync?.status === 'running' ? 5000 : false,
  })
}

export function useOrgSyncTrigger() {
  const qc = useQueryClient()
  return useMutation<OrgSyncTriggerResult, Error, void>({
    mutationFn: async () => {
      const res = await api.post<OrgSyncTriggerResult>('/v1/admin/org-sync')
      return res.data
    },
    onSuccess: () => {
      // Apenas inicia o polling do status; tenants/aws-ou-tree só são
      // invalidados quando o sync CONCLUIR (o disparo é assíncrono e os dados
      // ainda não estão prontos aqui). Ver OrgSyncButton.
      qc.invalidateQueries({ queryKey: ['org-sync-status'] })
    },
  })
}
